<template>
    <div class="card">
        <div class="card-body">
            <h4 class="title text-primary">{{ __('Age') }}</h4>
            <template v-if="loading">
                <Spinner spinner-type="grow" min-height="80%" />
            </template>
            <template v-else>
                <Chart :options="chartConfig" />
            </template>
        </div>
    </div>
</template>

<script>
import axios from "axios";
import Spinner from '../../components/Spinner';
import { Chart } from 'highcharts-vue';

export default {
    components: {
        Spinner,
        Chart,
    },

    data() {
        return {
            loading: false,
            chartConfig: this.getChartConfig(),
        }
    },

    mounted() {
        this.observe_visibility(this.$el, async () => {
            const counts = await this.fetchCounts();
            this.chartConfig.xAxis.categories = Object.keys(counts);
            this.chartConfig.series[0].data = Object.values(counts);
        });
    },

    methods: {
        async fetchCounts() {
            let counts = {};
            this.loading = true;
            await axios.get('/dashboard/age-wise-user-count')
                .then(({ data }) => counts = data.counts)
                .catch(console.error);

            this.loading = false;
            return counts;
        },

        getChartConfig() {
            const that = this;
            return {
                chart: {
                    type: 'column',
                },
                title: {
                    enabled: undefined,
                    text: '',
                    align: 'left'
                },
                legend: {
                    enabled: false,
                },
                tooltip: {
                    formatter: function () {
                        return '<b>' + this.series.name + '</b>: ' + that.en_to_bn(this.y);
                    },
                },
                plotOptions: {
                    column: {
                        pointPadding: 0.2,
                        borderWidth: 0
                    }
                },
                credits: {
                    enabled: false
                },
                yAxis: {
                    title: {
                        text: null
                    },
                    labels: {
                        formatter: function () {
                            return that.en_to_bn(this.value);
                        }
                    },
                },
                xAxis: {
                    categories: [],
                    labels: {
                        formatter: function () {
                            return that.en_to_bn(this.value);
                        }
                    },
                },
                series: [
                    {
                        name: this.__('Total'),
                        data: [],
                        color: '#509EE3'
                    },
                ],
                accessibility: {
                    enabled: false,
                },
            };
        },
    },
}
</script>